// extracted by mini-css-extract-plugin
export default {"root":"TtZuZJyzFEQbYBMpBZ4z","title":"pRx_1aCwozIzjG_0v_sh","label":"BnlRBLfXv6VdMAoHgoGE","private":"N7Ph0DSQjZaGTa_mGgHo"};